import React from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  label?: string;
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, label }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <button
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      style={{
        width: 36, height: 20,
        borderRadius: 10,
        background: checked ? 'var(--accent)' : 'var(--border)',
        border: 'none', cursor: 'pointer',
        position: 'relative',
        transition: 'background var(--transition-base)',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: 'absolute', top: 3, left: 3,
          width: 14, height: 14,
          background: '#fff', borderRadius: '50%',
          transition: 'transform var(--transition-base)',
          transform: checked ? 'translateX(16px)' : 'translateX(0)',
        }}
      />
    </button>
    {label && (
      <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
        {label}
      </span>
    )}
  </div>
);

export default Toggle;
